export const SET_GROUPS = 'SET_GROUPS';
export const SET_GROUP = 'SET_GROUP';
export const ADD_GROUP = 'ADD_GROUP';
export const UPDATE_GROUP = 'UPDATE_GROUP';
export const REMOVE_GROUP = 'REMOVE_GROUP';
export const CLEAR_GROUP = 'CLEAR_GROUP';
export const CLEAR_GROUPS = 'CLEAR_GROUPS';
